import React from "react";
import styles from "../drcarloscrepaldi/servicos_drcarloscrepaldi.module.scss";
import {
    ArrowLeft,
    Gavel,
    AlertTriangle,
    FileText,
    Briefcase,
    GraduationCap,
    Mic2,
} from "lucide-react";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import SiteIcon from "../../icons/siteIcon.tsx";
import { Link } from "react-router-dom";

// Função para gerar link do WhatsApp
const whatsappLink = (servico: string) =>
    `https://wa.me/5517981168113?text=Olá! Vim pelo seu cartão digital e gostaria de saber mais sobre ${encodeURIComponent(
        servico
    )}...`;

const Servicos_drcarloscrepaldi: React.FC = () => {
    // Lista de serviços com ícones
    const servicos = [
        {
            titulo: "Defesa Judicial e Crimes de Trânsito",
            descricao:
                "Atuação em ações que buscam anular multas, suspensões e cassações indevidas, além da defesa técnica em casos de embriaguez ao volante, lesão corporal e homicídio culposo.",
            Icon: Gavel,
        },
        {
            titulo: "Responsabilidade Civil e Perícia em Acidentes",
            descricao:
                "Ações de indenização por danos materiais e morais, com suporte técnico-pericial em colisões, frenagens e análise da dinâmica dos fatos.",
            Icon: AlertTriangle,
        },
        {
            titulo: "Recursos e Processos Administrativos",
            descricao:
                "Elaboração de defesas e recursos em todas as instâncias (JARI e CETRAN), incluindo conversão de multas em advertência e reabilitação de condutores.",
            Icon: FileText,
        },
        {
            titulo: "Consultoria Jurídica e Estratégica",
            descricao:
                "Orientação especializada para empresas, autoescolas e profissionais do setor, com foco em conformidade legal e gestão de riscos no trânsito.",
            Icon: Briefcase,
        },
        {
            titulo: "Educação e Treinamentos",
            descricao:
                "Cursos, palestras e workshops sobre Direito e Gestão de Trânsito, com foco prático e linguagem acessível para profissionais e cidadãos.",
            Icon: GraduationCap,
        },
        {
            titulo: "Conteúdo e Comunicação",
            descricao:
                "Criação de materiais educativos e apresentação do Podcast Pitacos de Trânsito, promovendo conscientização e cidadania no trânsito.",
            Icon: Mic2,
        },
    ];

    return (
        <div className={styles.servicos_drcarloscrepaldi}>
            {/* Header */}
            <div className={styles.header}>
                <Link to="/drcarloscrepaldi" className={styles.backButton}>
                    <ArrowLeft />
                </Link>
                <h1>Serviços</h1>
            </div>

            {/* Cards de serviços */}
            <div className={styles.services}>
                {servicos.map(({ titulo, descricao, Icon }, index) => (
                    <div className={styles.card} key={index}>
                        <Icon className={styles.icon} />
                        <h3>{titulo}</h3>
                        <p>{descricao}</p>
                        <a
                            href={whatsappLink(titulo)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.agendarButton}
                        >
                            <WhatsappIcon color="#fff" /> Agendar
                        </a>
                    </div>
                ))}
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <p className={styles.footerTitle}>
                    Dr. Carlos Crepaldi Jr • Advogado
                </p>
                <p className={styles.footerSubtitle}>
                    © {new Date().getFullYear()}. Todos os direitos reservados.
                </p>

                <div className={styles.footerLinks}>
                    <a
                        href="https://www.instagram.com/dr.carloscrepaldi?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw=="
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <InstagramIcon color="#fff" height="28" />
                    </a>
                    <a
                        href="https://maps.app.goo.gl/Qwc67DU9oovXN2Nb6"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <MapsIcon color="#fff" height="36" />
                    </a>
                    <a
                        href="http://www.2cadvocacia.com.br/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <SiteIcon color="#fff" width="28" height="28" />
                    </a>
                </div>
            </div>

            {/* Botão WhatsApp flutuante */}
            <a
                href="https://wa.me/5517981168113?text=Olá! Vim pelo seu cartão digital e gostaria de mais informações..."
                className={styles.whatsappFloat}
                target="_blank"
                rel="noopener noreferrer"
            >
                <WhatsappIcon color="#fff" />
            </a>
        </div>
    );
};

export default Servicos_drcarloscrepaldi;
